import styles from './HomePage.module.css';
import {React, useState, useEffect} from 'react';
import * as ColorSystem from '../../styles/colors';
import LayoutList from '../../components/LayoutList/LayoutList';
import { getLayoutPage } from '../../api/layoutApi';

const HomePage = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const res = await getLayoutPage(1, 10);
            setData(res.layouts || []);
        };
        fetchData();
    }, []);

  return (
    <div className={styles.homePage}>
      <h1 className={styles.title}>Welcome to the Home Page</h1>
      <LayoutList layouts={data} />
    </div>
  );
};

export default HomePage;
